import React, { useState } from "react";
import { Route, Switch } from "react-router-dom";
import Settings from 'content/SettingsView';
import Approvals from 'content/ApprovalsView';
import EventList from "./content/EventsList";
import * as path from "constants/path";
import Loader from "storybookComponents/Loader";
import NotificationBar from "components/NotificationBar";
import UserContext from 'context/UserContext';
import AppBar from "storybookComponents/Appbar";
import BreadCrumbs from "storybookComponents/Breadcrumbs";
import NotificationBell from "components/Notifications/index";
import Tasks from "components/Tasks/index"
import AppSwitcher, { AppSwitch } from "components/AppSwitcher"
import environment from "environments/environment";
import CreateEvent from "content/Event";
import { getSettings } from 'relay/main';
import Reports from "content/Reports";
import { getDrawerState, getBanner, setBanner } from "common";
import HyBlastApproverNotification from "components/ApproverRequestNotifications";
import ToastMessage from "storybookComponents/Toast";
import ExpiryNotificationPopup from "components/ExpiryNotificationPopup";
import ExpiredPage from "content/ExpiredPage";
import UnAuthorizedUserPage from "./public-routes/unauthorized";

const DefaultRoute = (props) => {

  React.useEffect(() => {

    let interval = setInterval(() => {
      if (props.propertyId) {
        clearInterval(interval);
        props.history.push(path.getAppPath())
      }
    }, 1000)

  }, [1])

  return <Loader />
}

const isUserApprover = (settings, current_email) => {
  if (!settings.approvalRequired) return true;
  return settings.approvalRequired && (settings.agentApprovalEmails.indexOf(current_email) > -1 ||
    settings.approverEmails.indexOf(current_email) > -1)
}


export default React.memo(({
  classes,
  toggleDrawer,
  selected_org,
  selected_property,
  user,
  propertyId,
  org,
  orgLevel,
  userRole,
  apps,
  approvalSubmenuTabs,
  hyeventsAccessApproval,
  setOriginNavItems,
  expiredAt,
  unauth,
  isExpired,
  ...rest
}) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [open, setOpen] = useState(true);
  const [showAppSwitcher, setShowAppSwitcher] = useState(false);
  const [pageTitle, setPageTitle] = useState('Events');
  const [loadingSetting, setLoadingSetting] = React.useState(true);
  const [approverSettings, setApproverSettings] = React.useState();
  const [approver, setApprover] = React.useState(false);
  const [approvalRequests, setApprovalRequests] = React.useState([]);
  const [later, setLater] = React.useState();
  const [isNotificationsBarVisible, setNotificationsBarVisible] = React.useState(false);
  const [showBannerHyevent, setShowBannerHyEvent] = React.useState(
    getBanner("hyEventApproverBanner")
  );
  const [toast, setToast] = React.useState({ open: false })


  let appPath = rest.history.location.pathname;
  let renderHyEventsApprovalFlow =
    (approver || userRole === "admin") ? true : false;

  React.useEffect(() => {
    loadSetting()
  }, [subOrgDetails.org.id, subOrgDetails.id]);

  React.useEffect(() => {
    window.parent.approvalNotif = (approvalRequests, total) => {
      setApprovalRequests(approvalRequests);
    }
  }, [1])

  React.useEffect(() => {
    if (!approverSettings) return
    setApprover(isUserApprover(approverSettings, user.username))
  }, [approverSettings])

  const toggleAppSwitcher = () => {
    setShowAppSwitcher(!showAppSwitcher)
    setOpen(false);
    if (typeof toggleDrawer === "function")
      toggleDrawer();
  }

  const onBreadcrumbClickedCallback = (e, breadcrumb) => {
    if (breadcrumb.active_state !== true) {
      rest.history.push(breadcrumb.to)
    }
    // window.location.replace(breadcrumb.to);
  }

  const onBreadcrumbIconClick = () => {
    if (pageTitle) {
      rest.history.push(pageTitle[pageTitle.length - 2].to)
    }
    // window.location.replace(pageTitle[pageTitle.length - 2].to);
  }

  const getBreadcrumbs = (pathname) => {
    if (Array.isArray(pathname)) {
      pathname[pathname.length - 1].active_state = true;
      return pathname;
    }
    return [{ label: pathname, active_state: true }];
  }

  const loadSetting = async () => {
    if (subOrgDetails.org.id && subOrgDetails.id) {
      setLoadingSetting(true)
      let settings = await getSettings(subOrgDetails.org.id, subOrgDetails.id);
      if (settings.hyeventsSetting) {
        setApproverSettings(settings.hyeventsSetting);
      }
      setTimeout(() => {
        setLoadingSetting(false)
      }, 1000)

    }
  }


  const handleBannerClose = (type) => {
    if (type == "hyEvents") {
      setShowBannerHyEvent(false);
      setBanner("hyEventApproverBanner");
    }
  };

  const updateEventsSettings = (settings) => setApproverSettings(settings);

  const TaskComponent = [
    {
      Component: HyBlastApproverNotification,
      props: {
        show: renderHyEventsApprovalFlow,
        orgId: subOrgDetails.org.id,
        hyEvents: true,
      },
    },
  ];
  const NotificationBellComponent = rest.orgLevelVisible
    ? []
    : [
      {
        Component: NotificationBell,
        props: {
          scope: "property_hyevents",
          environment,
          pool: true, //window.location.hostname !== "localhost",
          orgLevel: rest.orgLevelVisible,
        },
      },
    ];

  const closeToast = () => {
    setTimeout(() => {
      setToast({
        open: false,
        variant: toast.variant
      })
    }, 5000)
  }

  const forceCloseToast = () => {
    setToast({
      open: false,
      variant: toast.variant
    })
  }


  const showNotification = (message, type) => {
    setToast({
      open: true,
      variant: type,
      message
    })
  }

  return (

    <>
      {!isExpired && !unauth && <ExpiryNotificationPopup expiredAt={expiredAt} propertyId={propertyId} />}
      {
        loadingSetting ? <Loader /> :

          <div className={classes.appConatiner}>
            <ToastMessage
              variant={toast.variant}
              message={toast.message}
              open={toast.open}
              onCloseCallback={closeToast}
              onForceCloseCallback={forceCloseToast}
            />
            <div>
              <AppBar
                pageTitle={<BreadCrumbs xsWidth={window.innerWidth <= 600} allBreadcrumbs={getBreadcrumbs(pageTitle)} onBreadcrumbClickedCallback={onBreadcrumbClickedCallback} onIconClick={onBreadcrumbIconClick} />}
                onMenuIconClicked={toggleDrawer}
                notification={false}
                appswitcher
                onAppSwitcherClick={toggleAppSwitcher}
                no_shadow={false}
                no_border={false}
                xsWidth={Boolean(pageTitle) && typeof pageTitle === "object" && window.innerWidth <= 600}
                actions={(unauth || isExpired) ? [] : [...TaskComponent, ...NotificationBellComponent]}
              />
            </div>

            {renderHyEventsApprovalFlow && (!unauth && !isExpired) ? (
              <NotificationBar
                list={approvalRequests}
                show={showBannerHyevent}
                history={rest.history}
                handleCloseCallback={handleBannerClose}
                setNotificationsBarVisible={setNotificationsBarVisible}
              />
            ) : (
              false
            )}
            {
              showAppSwitcher ?
                <AppSwitcher
                  orgLevel={orgLevel}
                  org={{
                    id: subOrgDetails.org.id
                  }}
                  property={{
                    id: subOrgDetails.id,
                    propertyLogoUrl: subOrgDetails.propertyLogoUrl,
                    propertyManagerLogoUrl: subOrgDetails.propertyManagerLogoUrl,
                  }}
                  token={user.signInUserSession && user.signInUserSession.idToken.jwtToken}
                  closeAppSwitcher={toggleAppSwitcher}
                  apps={apps}
                /> :
                <>
                  {
                    unauth ? <Route path="/:propertyId">
                      {props => <UnAuthorizedUserPage unauth {...props} />}
                    </Route> :
                      expiredAt && isExpired ? <Route path="/:propertyId" component={ExpiredPage} /> :
                        <Switch>
                          <Route path="/" exact>
                            {
                              props => <DefaultRoute propertyId={propertyId} {...props} />
                            }
                          </Route>
                          <Route path={path.SETTINGS} exact>
                            {
                              props => <Settings
                                {...props}
                                setTitle={setPageTitle}
                                updateEventsSettings={updateEventsSettings}
                                approverSettings={approverSettings}
                                hyeventsAccessApproval={hyeventsAccessApproval}
                                isApprover={approver}
                                orgLevel={orgLevel}
                                setOriginNavItems={setOriginNavItems}
                                showNotification={showNotification}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path={path.APPROVALS} exact>
                            {
                              props => <Approvals
                                {...props}
                                setTitle={setPageTitle}
                                isApprover={approver}
                                orgLevel={orgLevel}
                                isAllTabsAccess={approvalSubmenuTabs == "approver"}
                                setOriginNavItems={setOriginNavItems}
                                showNotification={showNotification}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }

                          </Route>
                          <Route path={path.APP} exact>
                            {
                              props => <EventList
                                {...props}
                                approverSettings={approverSettings}
                                setTitle={setPageTitle}
                                isApprover={approver}
                                setOriginNavItems={setOriginNavItems}
                                orgLevel={orgLevel}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }

                          </Route>
                          <Route path={path.CREATE_EVENT} exact>
                            {
                              props => <CreateEvent
                                setTitle={setPageTitle}
                                {...props}
                                isDrawerOpen={Boolean(getDrawerState())}
                                username={user.username}
                                {...rest}
                                settings={approverSettings}
                                toggleDrawer={toggleDrawer}
                                isApprover={approver}
                                setOriginNavItems={setOriginNavItems}
                                orgLevel={orgLevel}
                                showNotification={showNotification}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path={path.EDIT_EVENT} exact>
                            {
                              props => <CreateEvent
                                {...props}
                                isDrawerOpen={Boolean(getDrawerState())}
                                setTitle={setPageTitle}
                                username={user.username}
                                {...rest}
                                settings={approverSettings}
                                toggleDrawer={toggleDrawer}
                                isApprover={approver}
                                loadingSetting={loadingSetting}
                                setOriginNavItems={setOriginNavItems}
                                orgLevel={orgLevel}
                                showNotification={showNotification}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path={path.REPORTS_OVERVIEW} exact>
                            {
                              props => <Reports
                                {...props}
                                activeTab={0}
                                setTitle={setPageTitle}
                                setOriginNavItems={setOriginNavItems}
                                orgLevel={orgLevel}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path={path.REPORTS_PROPERTIES} exact>
                            {
                              props => <Reports
                                {...props}
                                activeTab={1}
                                orgLevel={orgLevel}
                                setTitle={setPageTitle}
                                setOriginNavItems={setOriginNavItems}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path={path.REPORTS_EVENTS} exact>
                            {
                              props => <Reports
                                {...props}
                                activeTab={orgLevel ? 2 : 1}
                                setTitle={setPageTitle}
                                orgLevel={orgLevel}
                                setOriginNavItems={setOriginNavItems}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path={path.REPORTS_INVITEES} exact>
                            {
                              props => <Reports
                                {...props}
                                activeTab={orgLevel ? 3 : 2}
                                setTitle={setPageTitle}
                                orgLevel={orgLevel}
                                setOriginNavItems={setOriginNavItems}
                                isNotificationsBarVisible={isNotificationsBarVisible}
                              />
                            }
                          </Route>
                          <Route path="/">
                            {
                              props => <DefaultRoute propertyId={propertyId} {...props} />
                            }
                          </Route>
                        </Switch>
                  }
                </>
            }
            {/* </div> */}
          </div >
      }
    </>
  )
})